<template>
  <div class="personal-handle" v-loading="isLoading">
    <div class="nothing" v-if="isNothing">
      <AddTitle @success="createSuccess" v-if="!onlyReal"></AddTitle>
      <Nothing :config="{type: onlyReal ? 'img_no_data' : 'img_no_task',tip:onlyReal ? '暂无待办' : '暂无待办，去搬砖~'}"></Nothing>
    </div>
    <div class="content" :class="{'only-real':onlyReal}" v-else-if="completeList.length > 0  || todoList.length > 0 ">
      <div class="list">
        <AddTitle @success="createSuccess" v-if="!onlyReal" class="in-list-title"></AddTitle>
        <div class="dob-list">
          <div class="list-task unsubscribeTask" :style="{height:todoIsOpen ? 'auto' : '48px'}">
            <div class="list-task-title">
              <div><i class="icon iconfont iconicon_drop_down_arrow tableIconHover" :class="{'rota90': todoIsOpen}" @click="todoIsOpen = !todoIsOpen"></i><span>未完成</span><a>（{{todoTotal}}）</a></div>
              <el-dropdown @command="handleCommandTask" size="small" placement="bottom-start" trigger="click">
                <div class="el-dropdown-link">
                  <span class="status-change-ele">{{sortData[todo.sort_rule]}}</span>
                  <i class="icon iconfont iconicon_arrow_1"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item,key) in sortData" :key="key" :command="key">{{item}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <List @taskStatusChange="taskStatusChange" @colorChange="colorChange" @timeChange="timeChange" :dataset="todoList" @openDetail="openDetail" :finish="todoFinish" :load="todoLoad" :onlyReal="onlyReal" :itemMove="todo.sort_rule === 'move_sort'" :check="detailId"></List>
            <div v-if="todoList.length === 0 && todoFinish && todoIsOpen" class="not-task-box">
              <Nothing :config="{type: onlyReal ? 'img_no_data' : 'img_no_task',tip: onlyReal ? '暂无待办' : '暂无待办，去搬砖~'}"></Nothing>
            </div>
          </div>
          <div class="list-task" :style="{height:completeIsOpen ? 'auto' : '48px'}">
            <div class="list-task-title">
              <div><i class="icon iconfont iconicon_drop_down_arrow tableIconHover" :class="{'rota90': completeIsOpen}" @click="completeIsOpen = !completeIsOpen"></i><span>已完成</span><a>（{{completeTotal}}）</a></div>
            </div>
            <List @taskStatusChange="taskStatusChange" @colorChange="colorChange" @timeChange="timeChange" :dataset="completeList" @openDetail="openDetail" :finish="completeFinish" :load="completeLoad" :onlyReal="onlyReal" :sort_rule="todo.sort_rule" :check="detailId"></List>
          </div>
        </div>
      </div>
      <div class="detail">
        <Detail ref="detail" :id="detailId" @delSuccess="delSuccess" @taskStatusChange="detailStatusChange" @colorChange="detailColorChange" @timeChange="detailTimeChange" :onlyReal="onlyReal" @titleChange="titleChange"></Detail>
      </div>
    </div>
  </div>
</template>
<script>
import Nothing from '@/components/nothing'
import AddTitle from './addTitle'
import api from '@/services/api/mine/mine'
import SelectColor from './selectColor'
import SelectTime from './selectTime'
import Detail from './detail'
import { mapGetters } from 'vuex'
import List from './list'
export default {
  props: ['uid', 'onlyReal'],
  components: {
    AddTitle,
    Nothing,
    SelectColor,
    SelectTime,
    List,
    Detail
  },
  data() {
    let _this = this
    return {
      complete: {
        page: 1,
        number: 20,
        uid: _this.uid || ''
      },
      todo: {
        page: 1,
        number: 20,
        sort_rule: 'move_sort',
        uid: _this.uid || ''
      },
      completeList: [], // 已完成列表
      completeTotal: 0, // 已完成总数
      completeIsOpen: true, // 已完成是否展开
      completeFinish: false,
      todoList: [], // 未完成列表
      todoTotal: 0,// 未完成总数
      todoIsOpen: true, // 未完成是否展开
      todoFinish: false,
      colorList: [],// 颜色列表
      sortData: {
        move_sort: '按拖拽排序',
        due_date_sort: '按截止日期排序'
      },
      detailId: '',
    }
  },
  created() {
    api.getColorList({}).then(res => {
      this.colorList = res
    })
    this.complete.uid = this.uid || this.userInfo.uid
    this.todo.uid = this.uid || this.userInfo.uid
    this.init()
  },
  computed: {
    ...mapGetters("layout/layout", ['userInfo']),
    isNothing() {
      return this.completeList.length === 0 && this.todoList.length === 0 && this.todoFinish && this.completeFinish
    },
    isLoading() {
      return (!this.todoFinish && this.todoList.length === 0) || (!this.completeFinish && this.completeList.length === 0)
    }
  },
  methods: {
    createSuccess(id) {
      this.restTodo(async () => {
        await this.getTodoTask()
        this.detailId = id
      })
    },
    init() {
      this.getCompleteTask()
      this.getTodoTask()
    },
    getCompleteTask() {
      this.completeFinish = false
      return api.todoCompletedIndex(this.complete).then(res => {
        res.data.map(item => {
          if (item.color_mark && item.color_mark.id) {
            item.colorMark = item.color_mark.id
          }
        })
        this.completeList.push(...res.data)
        this.completeTotal = res.total
        if (this.completeList.length === this.completeTotal || res.data.length === 0) {
          this.completeFinish = true
        } else {
          this.completeFinish = false
        }
      })
    },
    getTodoTask() {
      this.todoFinish = false
      return api.todoUndoneIndex(this.todo).then(res => {
        res.data.map(item => {
          if (item.color_mark && item.color_mark.id) {
            item.colorMark = item.color_mark.id
          }
        })
        this.todoList.push(...res.data)
        this.todoTotal = res.total
        if (this.todoList.length === this.todoTotal || res.data.length === 0) {
          this.todoFinish = true
        } else {
          this.todoFinish = false
        }
      })
    },
    async taskStatusChange({ id, index, isCompete }, fl) {
      await api.todoUpdate({ id, status: isCompete ? 2 : 1 })
      // let key = isCompete ? 'todoTotal' : 'completeTotal' // 判断那个数组
      // this[key] - 1 < 0 ? this[key] = 0 : this[key] = this[key] - 1 // 相应数量-1
      // if (isCompete) {
      //   this.restComplete(() => {
      //     this.getCompleteTask()
      //   })
      //   this.todoList.splice(index, 1)
      // } else {
      //   this.restTodo(() => {
      //     this.getTodoTask()
      //   })
      //   this.completeList.splice(index, 1)
      // }
      this.restComplete(() => {
        this.getCompleteTask()
      })
      this.restTodo(() => {
        this.getTodoTask()
      })
      if (!fl) {
        this.detailRest()
      }
    },
    async colorChange({ item }, fl) {
      await api.todoUpdate({ id: item.id, color_mark: item.colorMark })
      this.updateWitchArr(item)
      if (!fl) {
        this.detailRest()
      }
    },
    async timeChange({ item }, fl) {
      await api.todoUpdate({ id: item.id, due_date: item.due_date })
      this.updateWitchArr(item)
      if (!fl) {
        this.detailRest()
      }
    },
    async updateWitchArr(item) {
      let isCompete = item.status === 2
      // let list = isCompete ? 'completeList' : 'todoList'
      // let result = await api.todoDetail({ id })
      // let count = isCompete ? 'completeTotal' : 'todoTotal'
      // let index = this[list].findIndex(res => res.id === id)
      // this[list].splice(index, 1, result)
      if (isCompete) {
        this.restComplete(() => {
          this.getCompleteTask()
        })
      } else {
        this.restTodo(() => {
          this.getTodoTask()
        })
      }
    },
    openDetail(id) {
      this.detailId = id
    },
    delSuccess({ id, isCompete }) {
      // let key = isCompete ? 'completeList' : 'todoList'
      // let total = isCompete ? 'completeTotal' : 'todoTotal' // 判断那个数组
      // this[total] - 1 < 0 ? this[total] = 0 : this[total] = this[total] - 1 // 相应数量-1
      // let index = this[key].findIndex(res => res.id === id)
      // this[key].splice(index, 1)
      this.detailId = ''
      this.restComplete(() => {
        this.getCompleteTask()
      })
      this.restTodo(() => {
        this.getTodoTask()
      })
    },
    detailStatusChange(item) {
      let isCompete = item.status === 1 ? false : true
      let key = isCompete ? 'todoList' : 'completeList'
      let index = this[key].findIndex(res => res.id === item.id)
      console.log(item, this[key])
      this.taskStatusChange({ id: item.id, index, isCompete })
    },
    detailColorChange(item) {
      this.colorChange({ item }, true)
    },
    detailTimeChange(item) {
      this.timeChange({ item })
    },
    async completeLoad(resolve) {
      this.complete.page = this.complete.page + 1
      await this.getCompleteTask()
      resolve()
    },
    async todoLoad(resolve) {
      this.todo.page = this.todo.page + 1
      await this.getTodoTask()
      resolve()
    },
    handleCommandTask(data) {
      if (this.todo.sort_rule === data) return
      this.todo.sort_rule = data
      this.restTodo(() => {
        this.getTodoTask()
      })
    },
    async titleChange(item) {
      let isCompete = item.status === 1 ? false : true
      let key = isCompete ? 'completeList' : 'todoList'
      let index = this[key].findIndex(res => res.id === item.id)
      await api.todoUpdate({ id: item.id, title: item.title })
      let result = await api.todoDetail({ id: item.id })
      this[key].splice(index, 1, result)
    },
    restComplete(resolve) {
      this.complete.page = 1
      this.completeList = []
      this.completeTotal = 0
      this.$nextTick(() => {
        resolve()
      })
    },
    restTodo(resolve) {
      this.todoList = []
      this.todoTotal = 0
      this.todo.page = 1
      this.$nextTick(() => {
        resolve()
      })
    },
    detailRest() {
      if (this.detailId) {
        this.$refs.detail.init()
      }
    }
  }
}
</script>
<style lang="scss">
.personal-handle {
  display: flex;
  justify-content: center;
  height: 100%;
  // max-width: 1440px;
  // margin:0 auto;
  ::-webkit-scrollbar-thumb{
    background-color: #fff;
  }
  .only-real {
    .unsubscribeTask {
      margin-top: 16px !important;
    }
    .list {
      padding-top: 0 !important;
    }
  }
  .nothing {
    width: 981px;
    margin-top: 24px;
  }
  .list {
    width: 65%;
    border-right: 1px solid rgba(231, 232, 237, 0.6);
    height: 100%;
    box-sizing: border-box;
    padding:24px 40px;
    position: relative;
    display: flex;
    flex-direction: column;
    .dob-list{
      overflow-x: hidden;
      flex: 1;
      height: 0;
      margin-top: 24px;
    }
    .in-list-title{
      // padding-top:24px;
    }
    .unsubscribeTask {
      position: relative;
    }
  }
  .detail {
    position: relative;
    // width: 598px;
    width: 35%;
    padding: 24px 40px;
    padding-top: 0 ;
    box-sizing: border-box;
    flex-shrink: 0;
  }
  .content {
    display: flex;
    width: 100%;
    height: 100%;
  }
  .not-task-box {
    height: 400px;
    position: relative;
  }
  .list-task {
    overflow: hidden;
    margin-bottom: 12px;
  }
  .list-task-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 48px;
    padding: 0 24px;
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
    .el-dropdown-link {
      display: inline-block;
      height: auto;
      padding: 0;
      .status-change-ele {
        font-size: 14px;
      }
    }
    i {
      font-size: 14px;
      cursor: pointer;
      user-select: none;
      transition: all .3s;
      color: rgba(32, 32, 32, 0.24);
    }
    > div:first-child {
      font-size: 12px;
      color: rgba(32, 32, 32, 0.6);
      span {
        font-size: 16px;
        color: initial;
        font-weight: bold;
        margin: 0 0 0 4px;
      }
    }
    > div:last-child {
      font-size: 12px;
      color: rgba(32, 32, 32, 0.6);
      cursor: pointer;
      span {
        margin-right: 0;
      }
    }
  }
}
</style>
